"use strict";

var questions = [{
  prompt: "A copy of your responses will be sent to your coach. You’ll also be able to see a copy yourself here in the Uprise app",
  type: "multi",
  options: [],
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, {
  prompt: "",
  extraText: "Please write a very short description of the problem that’s making it harder to return to work",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Why is it a problem?",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "When, with whom and where does it happen?",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What have I tried to do about this problem?",
  placeholder: "",
  type: "multirow",
  aggregated: true
}];
var complete = "Thanks for completing the exercise. A copy of what you’ve written will be available to view shortly and we’ll send your responses to your coach as well.";

var analysis = function analysis(answers) {
  return {
    answer1: answers[1],
    answer2: answers[2],
    answer3: answers[3],
    answer4: answers[4]
  };
};

module.exports = {
  questions: questions,
  complete: complete,
  analysis: analysis
};